"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_flatten_1 = __importDefault(require("lodash.flatten"));
var lodash_isequal_1 = __importDefault(require("lodash.isequal"));
var lodash_sortby_1 = __importDefault(require("lodash.sortby"));
var STANDART_MAX_DEVIATION = 15;
var GenericUtilsService = (function () {
    function GenericUtilsService() {
    }
    GenericUtilsService.getDeviation = function (array) {
        if (array.length < 2)
            return 0;
        var deviationSum = array.reduce(function (sum, value) { return sum + value; }, 0);
        var normalizedDeviation = deviationSum / (array.length - 1);
        return Math.sqrt(normalizedDeviation);
    };
    GenericUtilsService.flattenArray = function (array) {
        return (0, lodash_flatten_1.default)(array);
    };
    GenericUtilsService.getRandomArbitraryNumber = function (min, max) {
        return Math.random() * (max - min) + min;
    };
    GenericUtilsService.isDeviationNotNormal = function (array, maxDeviation) {
        if (!array.length)
            return false;
        var deviation = this.getDeviation(array);
        return deviation > (maxDeviation !== null && maxDeviation !== void 0 ? maxDeviation : STANDART_MAX_DEVIATION);
    };
    GenericUtilsService.getArrayIterator = function (array) {
        var i;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!true) return [3, 3];
                    return [4, array[i % array.length]];
                case 2:
                    _a.sent();
                    i += 1;
                    return [3, 1];
                case 3: return [2];
            }
        });
    };
    GenericUtilsService.areArraysEqual = function (arr1, arr2) {
        return (0, lodash_isequal_1.default)((0, lodash_sortby_1.default)(arr1), (0, lodash_sortby_1.default)(arr2));
    };
    return GenericUtilsService;
}());
exports.default = GenericUtilsService;
//# sourceMappingURL=index.js.map